export function selectMaxParticipantStreamDelay(delays) {
    const noResultDelay = {
        uuid: undefined,
        delay: undefined,
        systemInfo: undefined,
    };
    const maxDelay = delays.sort((a, b) => b.delay - a.delay)[0];
    return maxDelay || noResultDelay;
}
